import React, { ChangeEvent, useCallback, useState ,useEffect} from 'react';
import { Link ,useLocation} from 'react-router-dom';
import MdalCommUi from 'Utils/MdalCommUi';
import { Helmet } from 'react-helmet-async';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import MgpStore from "Stores/Store";
import "Assets/css/MembJoin.css"
import TrmsCtxtInqApi from 'Apis/TrmsCtxtInqApi';
import TrmsCtxtUi from 'Views/Trms/TrmsCtxtUi';
import CptchUi from 'Utils/CptchUi';

MgpStore.subscribe(() => MgpStore.getState());


declare global {
    interface Window { emlAthnRespFunc: any; }
}
const AppMembJoinPage = () => {
    const location = useLocation();
    const [joinTypeCd,setJoinTypeCd] = useState<string>("NRML");
    const [referrer,setReferrer] = useState<string>("");
    // location.state will be read inside the effect
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [mdalState,setmdalState] = useState(false);
    const [mdalCtxtTitlState,setMdalCtxtTitlState] = useState("");
    const [mdalTitlState,setMdalTitlState] = useState("");
    const [agreChkState,setAgreChkState] = useState<string[]>([]);
    const [emlAthnPrpsCd] = useState("MEMB_JOIN");
    const [membEmlAddr,setMembEmlAddr] = useState<string|null>(null);
    const [emlAthnState,setEmlAthnState] = useState("N");
    const [agreChkYnState,setAgreChkYnState] = useState("N");
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (670/2));
    const AgreTrmsFunc = (e:ChangeEvent<HTMLInputElement>) => {
        if(e.target.name =="agreAll") {
            e.target.checked
            ? setAgreChkState(["agreStipulation","agrePrivacy"])
            : setAgreChkState([]);
        }else {
            e.target.checked
            ? setAgreChkState([...agreChkState,e.target.name])
            : setAgreChkState(agreChkState.filter((choice)=> choice !== e.target.name));
        }
    }
    const mdalOpener = useCallback((e:string|null)=> {
        if(e != null) {
            setMdalCtxtTitlState(e);
            switch(e) {
                case 'TRMS_USE':
                    setMdalTitlState(langData&&langData.GLB_TRMS_TRM_USE_TITL_00);
                    break;
                case 'TRMS_PRV_PLC':
                    setMdalTitlState(langData&&langData.GLB_FTR_PRIVACY_MAIN_BTN_00);
                    break;
                default:
                    setMdalTitlState("");
                    break;
            }
        }
        setmdalState(!mdalState);
    },[mdalState,setmdalState,langData]);
    
    const EmlAthnPopFunc = (e:any)=>{
        window.open(e,"_blank","width=550,height=670 left="+popupX+"top="+popupY);
    }
    const membJoinFormTxt = [langData&&langData.LOGIN_FIND_LOGIN_ID_BTN_00,langData&&langData.LOGIN_FIND_PASSWD_MAIN_BTN_00,langData&&langData.LOGIN_MEMB_JOIN_MAIN_BTN_00];

    useEffect(() => {
        const locationState = (location && location.state) ? (location.state as { joinTypeCd?: string }) : null;
        if (locationState && locationState.joinTypeCd) {
            setJoinTypeCd(locationState.joinTypeCd);
            console.log('locationState.joinTypeCd', locationState.joinTypeCd);
        }

        // 이전 페이지 URL 저장
        const previousPage = document.referrer || window.location.origin;
        setReferrer(previousPage);

        function emlAthnRespFunc(athnPrpsCd: string, emlAddr: string) {
            if (athnPrpsCd === emlAthnPrpsCd) {
                setEmlAthnState('Y');
                setMembEmlAddr(emlAddr);
            }
        }
        window.emlAthnRespFunc = emlAthnRespFunc;

        return () => {
            // cleanup global handler when component unmounts or location changes
            try { window.emlAthnRespFunc = undefined; } catch (e) {}
        };
    }, [location]);
    return(
        <>
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.GLB_HDR_MEMB_JOIN_BTN_00}`}</title>
        </Helmet>
        <div className='BgW'>
            <div className='membJoinChkForm'>
                <div className='membIconWrap'>
                    <img src={process.env.PUBLIC_URL+'/images/membIcon.png'} alt="" />
                </div>
                <div className='membJoinCtxtWrap'>
                    <div className='agreAll agreLi'>
                        <input type="checkbox" name='agreAll' className='agreChkBox'  id='agreAllChk' checked={agreChkState.length ==2 ? true : false} onChange={AgreTrmsFunc}/>
                        <label htmlFor="agreAllChk">{langData&&langData.MEMB_JOIN_ALL_AGRE_BTN_00}</label>
                    </div>
                    <div className='agreSub'>
                        <div className='agreLi'>
                            <div>
                                <input type="checkbox" name='agreStipulation' className='agreChkBox' id='agreStipulation' checked={agreChkState.includes('agreStipulation')} onChange={AgreTrmsFunc}/>
                                <label htmlFor="agreStipulation">{langData&&langData.MEMB_JOIN_TRMS_AGRE_BTN_00}</label>
                            </div>
                            <div className='trmsLiModal mdalTrigger' onClick={() => mdalOpener('TRMS_USE')}>
                                <span>{langData&&langData.MEMB_JOIN_VIEW_MORE_BTN_00}</span>
                            </div>
                        </div>
                        <div className='agreLi'>
                            <div>
                                <input type="checkbox" name='agrePrivacy' className='agreChkBox' id='agrePrivacy' checked={agreChkState.includes('agrePrivacy')} onChange={AgreTrmsFunc}/>
                                <label htmlFor="agrePrivacy">{langData&&langData.MEMB_JOIN_PRIVACY_AGRE_BTN_00}</label>
                            </div>
                            <div className='trmsLiModal mdalTrigger' onClick={() => mdalOpener('TRMS_PRV_PLC')}>
                                <span>{langData&&langData.MEMB_JOIN_VIEW_MORE_BTN_00}</span>
                            </div>
                        </div>
                            <div className='emlAthnWrap'>
                                <p>{langData&&langData.MEMB_JOIN_EML_ATHN_BTN_00}</p>
                                
                                {emlAthnState != "Y"?
                                    <button onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=' + emlAthnPrpsCd + "&lang=" +MgpStore.getState().LangSetState.Lang}`)}>
                                        <span>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</span>
                                    </button>:
                                    <div className='disableBtn'>
                                        <span>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_01}</span>
                                    </div>
                                }
                            </div>
                            {emlAthnState == "Y" && agreChkState.length == 2?
                                <div>
                                    {(() => {
                                        const getReferrerTarget = () => {
                                            try {
                                                const ref = referrer || '';
                                                const url = new URL(ref, window.location.origin);
                                                const pathname = (url.pathname || '').toLowerCase();
                                                if (pathname.startsWith('/gamepage')) {
                                                    const params = new URLSearchParams(url.search);
                                                    // find exact gameSvcCd param (case-insensitive)
                                                    let gameSvcVal: string | null = null;
                                                    params.forEach((v, k) => {
                                                        if (k.toLowerCase() === 'gamesvccd') {
                                                            gameSvcVal = v;
                                                        }
                                                    });
                                                    if (gameSvcVal) {
                                                        // normalize href to exactly /gamepage?gameSvcCd=xxx
                                                        return { useAnchor: true, href: `/gamepage?gameSvcCd=${encodeURIComponent(gameSvcVal)}` };
                                                    }
                                                }
                                            } catch (e) {
                                                // fallback
                                            }
                                            return { useAnchor: false, href: '/' };
                                        };

                                        const target = getReferrerTarget();
                                        if (target.useAnchor) {
                                            return (
                                                <a className="nextPageBtn" href={target.href}>
                                                    <span>메인 페이지로 이동</span>
                                                </a>
                                            );
                                        }
                                        return (
                                            <Link className="nextPageBtn" to={target.href}>
                                                <span>메인 페이지로 이동</span>
                                            </Link>
                                        );
                                    })()}
                                </div>
                            :
                            <div className='nextPageBtn disable'>
                                <span>{langData&&langData.MEMB_JOIN_WITH_TRMS_BTN_00}</span>
                            </div>
                            }
                    </div>
                </div>
            </div>
        </div>

        {mdalState && (
            <div className='mdalTrmsWrap'>
                <div className='mdalBg' onClick={()=>mdalOpener(null)}></div>
                <div className='mdalTrmsContainer'>
                    <div className='trmsMdalHeader'>
                            <h1>{mdalTitlState}</h1>
                        <div className='trmsMdalCloseBtn' onClick={()=>mdalOpener(null)}><i className="close"></i></div>
                    </div>
                    <TrmsCtxtUi gameSvcCd={"mgp"} trmsKindCd={mdalCtxtTitlState} mdalFunc={()=>mdalOpener(null)}></TrmsCtxtUi>
                    <button className='trmsAgreeBtn' onClick={()=>mdalOpener(null)}>
                        <p>{langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}</p>
                    </button>
                </div>
            </div>
            // <MdalCommUi mdalType={"modalType01"} mdalCtxtTitl={mdalCtxtTitlState} mdalSize={"w500"} mdalFunc={()=>mdalOpener(null)} />
        )}
        </>
    )
}

export default AppMembJoinPage;
<script type="text/javascript" src="https://pay.billgate.net/paygate/plugin/gx_web_client.js" />